import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@paypalcorp/pp-react';
import {
  PARTNERS_TITLE,
  MARKETPLACES_TITLE,
  CHECKOUT
} from '../../../lib/constants';
import {
  recordIntent,
  productToRPSMapping
} from '../../../lib/appcenterIntent';
import {
  fireDetailsPageComponentFailureFpti,
  parseData,
  getUtmParams
} from '../../../lib/helpers';

const DetailsHeader = ({
  componentContent = {},
  handleClickFPTI,
  fptiImpression,
  app = {},
  location = {},
  experimentation = {}
}) => {
  const { title, subtitle, button, appIcon, toolKey } = componentContent;
  const { coloredIconsExp: isColoredIconsEligible } = experimentation;

  let buttonItems = {};

  if (button) {
    buttonItems = parseData(button)[0];
  }

  const {
    text: buttonText,
    url: buttonUrl,
    subText: buttonSubtext
  } = buttonItems;

  let appIconItems = {};

  if (appIcon) {
    appIconItems = parseData(appIcon)[0];
  }

  const { url: imageURL } = appIconItems;
  const coloredImgUrl =
    isColoredIconsEligible && appIconItems.urlColored
      ? appIconItems.urlColored
      : '';

  if (!title || !subtitle || !buttonText || !buttonUrl || !imageURL) {
    fireDetailsPageComponentFailureFpti({
      data: { title, subtitle, buttonText, buttonUrl, imageURL },
      componentName: 'DetailsHeader',
      fptiImpression
    });
    return null;
  }
  const locationValue = location.pathname ? location.pathname.split('/') : [];
  const locationCategory =
    locationValue.length !== 0 ? locationValue[locationValue.length - 2] : '';
  const partnerMarket =
    locationCategory === PARTNERS_TITLE ||
    locationCategory === MARKETPLACES_TITLE;
  const ctaRedirect = url => {
    const {
      utm_source,
      utm_medium,
      utm_campaign,
      utm_content
    } = getUtmParams();
    const source = utm_source,
      medium = utm_medium,
      content = utm_content,
      campaign = utm_campaign;

    if ((source || medium || campaign || content) && url) {
      let divider = '?';
      const urlQueryParams = new URL(url, `https://www.paypal.com`).search; //This line  checks if the URL has some query params.
      if (urlQueryParams) {
        divider = '&';
      }
      const sourceUtmParam = source ? `utm_source=${source}` : '';
      const mediumUtmParam = medium ? `&utm_medium=${medium}` : '';
      const campaignUtmParam = campaign ? `&utm_campaign=${campaign}` : '';
      const contentUtmParam = content ? `&utm_content=${content}` : '';
      const urlWithUtmParams = `${url}${divider}${sourceUtmParam}${mediumUtmParam}${campaignUtmParam}${contentUtmParam}`;
      window.location = urlWithUtmParams;
    } else {
      window.location = url;
    }
  };
  const handleClick = () => {
    handleClickFPTI('get_started');
    if (productToRPSMapping[toolKey]) {
      rpsRecordIntent(buttonUrl);
    } else if (toolKey === CHECKOUT) {
      handleCheckoutCase();
    } else {
      ctaRedirect(buttonUrl);
    }
  };
  const rpsRecordIntent = url => {
    recordIntent({
      csrf: app.csrf,
      productArr: [productToRPSMapping[toolKey]]
    }).finally(() => {
      ctaRedirect(url);
    });
  };

  const handleCheckoutCase = () => {
    const htmlElement = document.querySelector('#details-section-header');
    window.scrollTo(0, (htmlElement || {}).offsetTop);
  };

  return (
    <section id="details-header">
      <div className="details-header-container">
        <div className="container-one">
          <div
            className={
              !isColoredIconsEligible
                ? 'details-header-image old'
                : 'details-header-image'
            }
            style={
              !isColoredIconsEligible
                ? {
                    background: `url(${imageURL}) center center no-repeat`,
                    backgroundSize: partnerMarket ? '100%' : '80%',
                    ...(partnerMarket && { border: '0' })
                  }
                : {
                    background: `url(${coloredImgUrl ||
                      imageURL}) center center no-repeat`,
                    backgroundSize: '100%'
                  }
            }
          ></div>
        </div>
        <div className="container-two">
          <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
          <p dangerouslySetInnerHTML={{ __html: subtitle }}></p>
        </div>
        <div className="container-three">
          <Button onClick={handleClick}>{buttonText}</Button>
          {buttonSubtext && <p> {buttonSubtext} </p>}
        </div>
      </div>
    </section>
  );
};

DetailsHeader.propTypes = {
  componentContent: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  imageURL: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonText: PropTypes.string,
  buttonSubtext: PropTypes.string,
  app: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  location: PropTypes.object,
  fptiImpression: PropTypes.func.isRequired,
  toolName: PropTypes.string,
  experimentation: PropTypes.object
};

export default DetailsHeader;
